import styled from 'styled-components';

import { Tick as TickSVG, Minus as MinusSVG } from '@solent-university/solent-icons';

export const Wrapper = styled.div`
    width: 2rem;
    margin: 0 auto;
`;

export const Tick = styled(TickSVG)`
    color: ${({ theme }) => theme.colors.primary.hex};
`;

export const Dash = styled(MinusSVG)`
    color: ${({ theme }) => theme.colors.secondary.tints[1].hex};
`;
